import { useCallback, useEffect, useState } from 'react';
import EventBus from '@/libs/eventBus/eventBus';
import { CustomEvents } from '@/libs/eventBus/constants';
import { SelectionElementData, SelectionOutlineAction } from '@/App/remotion/components/Outlines/types';
import { SelectionElementType } from '@/player-config/src/types/RemotionPlayerConfigTypes/CompositionConfig';

export const useSelectionOutline = () => {
  const [selectedElement, setSelectedElement] = useState<SelectionElementType | null>(null);
  const [selectedElementPosition, setSelectedElementPosition] = useState<React.CSSProperties['top']>(undefined);
  const [selectedElementData, setSelectedElementData] = useState<SelectionElementData | undefined>(undefined);

  const handleSelectionOutlineAction = useCallback(
    (payload: {
      action: SelectionOutlineAction;
      elementType: SelectionElementType;
      position?: React.CSSProperties['top'];
      data?: SelectionElementData;
    }) => {
      switch (payload.action) {
        case SelectionOutlineAction.SELECT:
        case SelectionOutlineAction.UPDATE_POSITION:
          setSelectedElement(payload.elementType);
          setSelectedElementPosition(payload.position);
          setSelectedElementData(payload.data);
          break;
        case SelectionOutlineAction.DESELECT:
          setSelectedElement(null);
          setSelectedElementPosition(undefined);
          setSelectedElementData(undefined);
          break;
        default:
          setSelectedElement(null);
          setSelectedElementPosition(undefined);
          setSelectedElementData(undefined);
      }
    },
    []
  );

  useEffect(() => {
    const selectListener = EventBus.on(CustomEvents.SelectionOutlineAction, handleSelectionOutlineAction);

    return () => {
      EventBus.off(CustomEvents.SelectionOutlineAction, selectListener);
    };
  }, [handleSelectionOutlineAction]);

  return { selectedElement, selectedElementPosition, selectedElementData };
};
